import { QuickFiltersValueDisplayUses } from '../../types/quickFilters/QuickFiltersValueDisplayUses';
import DisplayValueDuration from 'customer-data-filters-ui/components/display/DisplayValueDuration';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import QuickFiltersTags from './QuickFiltersTags';
import { jsx as _jsx } from "react/jsx-runtime";
const isInRangeInstance = condition => {
  return 'highValue' in condition;
};
const QuickFiltersDurationValueDisplay = props => {
  const {
    condition,
    onValueDelete,
    use
  } = props;
  const {
    name,
    value
  } = condition;
  const options = {
    value: /*#__PURE__*/_jsx(DisplayValueDuration, {
      value: value
    })
  };
  if (isInRangeInstance(condition)) {
    options.highValue = /*#__PURE__*/_jsx(DisplayValueDuration, {
      value: condition.highValue
    });
  }
  const label = /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: `customerDataFiltersUI.quickFilters.filterOperatorTranslations.DURATION_NUMBER.${name}`,
    options: options
  });
  if (use === QuickFiltersValueDisplayUses.STRING) {
    return label;
  }
  const tags = [{
    value: name,
    label
  }];
  return /*#__PURE__*/_jsx(QuickFiltersTags, {
    tags: tags,
    onTagClose: () => onValueDelete()
  });
};
export default QuickFiltersDurationValueDisplay;